import { css } from "../../../../../styled-system/css";

export const styles = {
  vinSearchWrapper: () =>
    css({
      "& form": {
        marginY: "baseUnit.mobile4",
        marginX: "auto",
        tabletLandscape: {
          marginTop: "baseUnit.mobile4",
          marginBottom: "baseUnit.mobile2",
          marginX: "auto",
        },
      },
    }),
};
